import clsx from 'clsx'
import React from 'react'
import InputLabel from './InputLabel'

const Textarea = ({
  name,
  required,
  label,
  description,
  touched,
  error,
  handleChange,
  handleBlur,
  value,
  type,
  placeholder,
  disabled,
  rows = 4,
  className,
}) => {
  return (
    <div className={clsx('relative space-y-2', className)}>
      <div>
        {label && (
          <InputLabel htmlFor={name} required={required}>
            {label}
          </InputLabel>
        )}
        {description && <p className="text-sm text-gray-500">{description}</p>}
      </div>
      <textarea
        className={clsx(
          'max-h-64 shadow-sm mt-1 block w-full sm:text-sm border-gray-300 rounded-md disabled:opacity-60 disabled:cursor-not-allowed',
          {
            'border-red-300 placeholder-red-600 text-red-600 focus:ring-red-400 focus:border-red-300':
              touched && error,
          }
        )}
        rows={rows}
        name={name}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        type={type}
        placeholder={placeholder}
        disabled={disabled}
      />
      {error && (
        <div className="block relative">
          <span className="text-red-500 font-normal text-sm leading-normal">
            {error}
          </span>
        </div>
      )}
    </div>
  )
}

export default Textarea
